import React, { createContext, useState } from 'react';

export const QuotationContext = createContext();

export const QuotationProvider = ({ children }) => {
  // Initialize selectedItems array
  const [selectedItems, setSelectedItems] = useState([]);
  
  // Initialize additionalNotes
  const [additionalNotes, setAdditionalNotes] = useState('');
  
  // Initialize quotationData with all required fields
  const [quotationData, setQuotationData] = useState({
    date: '',
    refNo: '',
    to: '',
    shipTo: '',
    additionalNotes: '',
    items: []
  });

  // Initialize quotations array to store all created quotations
  const [quotations, setQuotations] = useState([]);

  // ADDED: State to hold the temporary form draft data
  const [draft, setDraft] = useState(null);

  // Function to add a new quotation
  const addQuotation = (quotation) => {
    setQuotations(prev => [...prev, quotation]);
    // Clear the form data after adding quotation
    setSelectedItems([]);
    setAdditionalNotes('');
    setQuotationData({
      date: '',
      refNo: '',
      to: '',
      shipTo: '',
      additionalNotes: '',
      items: []
    });
  };

  return (
    <QuotationContext.Provider value={{
      selectedItems,
      setSelectedItems,
      additionalNotes,
      setAdditionalNotes,
      quotationData,
      setQuotationData,
      quotations,
      setQuotations,
      addQuotation,
      // ADDED: Expose the draft state and its setter function
      draft,
      setDraft
    }}>
      {children}
    </QuotationContext.Provider>
  );
};

export default QuotationProvider;